// 3rd-party
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

// Components
import Spinner from "../../components/spinner/Spinner";
import IndiaImageFormDialog from "./IndiaImageFormDialog";

// Services
import { logout } from "../../services/IndiaService";
import { getStorageItemLocal } from "../../services/storageServices";

// Config
import { appConfig } from "../../config/appConfig";

// AssetComponents
import edit from "../../assets/edit.svg";
import delete1 from "../../assets/delete.svg";
import add from "../../assets/add.svg";
import approve from "../../assets/approve.svg";
import visiable from "../../assets/visiable.svg";

// Styles
import "./IndiaImage.scss";

type AdminEntry = {
  [x: string]: any;
  id: number;
  categoryName?: string;
  categoryId?: number;
  imageName: string;
  imageUrls: string | string[];
  isActive: boolean;
  status: string;
};
interface Catgry {
  id: number;
  name: string;
}

const IndiaImage = () => {
  const [dataList, setDataList] = useState<AdminEntry[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [categories, setCategories] = useState<Catgry[]>([]);

  const [formData, setFormData] = useState<AdminEntry>({
    id: 0,
    imageName: "",
    imageUrls: [],
    isActive: false,
    status: "",
    categoryName: "",
    categoryId: 0,
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const rowsPerPage = 8;
  const [role, setRole] = useState<string>("");
  const navigate = useNavigate();
  useEffect(() => {
    const storedRole = getStorageItemLocal("role");

    if (storedRole) setRole(JSON.parse(storedRole));

    const fetchCategories = async () => {
      try {
        const tokenString = getStorageItemLocal("token");
        const token = tokenString ? JSON.parse(tokenString) : null;
        const response = await fetch(
          `${appConfig.serviceUrls.getAdminEntries}/categories`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!response.ok) throw new Error("Failed to fetch categories");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories", error);
      }
    };

    fetchCategories();
  }, []);
  useEffect(() => {
    const savedData = localStorage.getItem("adminDataList");
    if (savedData) {
      const parsedData: AdminEntry[] = JSON.parse(savedData);
      setDataList(parsedData);
      if (!savedData || parsedData.length === 0) {
        setEditingIndex(null);
      }
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (editingIndex !== null) {
      const selectedEntry = dataList.find((item) => item.id === editingIndex);
      if (selectedEntry) {
        const imageUrls =
          typeof selectedEntry.imageUrls === "string"
            ? selectedEntry.imageUrls.split(",")
            : Array.isArray(selectedEntry.imageUrls)
              ? selectedEntry.imageUrls
              : [];
        setFormData({
          ...selectedEntry,
          imageUrls,
        });
      }
    }
  }, [editingIndex, dataList]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      // TODO
      const response = await fetch(
        appConfig.serviceUrls.saveIndiaImageEntries,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }
      if (!response.ok) throw new Error("Failed to fetch data");
      const data: AdminEntry[] = await response.json();
      // Sort category-wise

      const sortedData = data.sort((a, b) => {
        const nameA = a.categoryName ?? "";
        const nameB = b.categoryName ?? "";

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        return a.id - b.id;
      });

      setDataList(sortedData || []);
      const { syncExtraCategoriesToBlob } = await import(
        "../../services/ExtraCategoriesSyncService"
      );
      syncExtraCategoriesToBlob();
      // setDataList(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      id: dataList.length + 1, // Increment ID
      imageName: "",
      categoryName: "",
      categoryId: 0,
      imageUrls: [],
      isActive: false,
      status: "",
    });
    setEditingIndex(null);
  };

  const handleAdd = () => {
    setEditingIndex(null);
    setShowForm(true);
    // TODO
    setFormData({
      id: 0,
      imageName: "",
      categoryName: "",
      categoryId: 0,
      imageUrls: [],
      isActive: false,
      status: "",
    });
  };

  const handlePublish = async (index: number) => {
    if (!window.confirm("Are you sure you want to publish this entry?")) return;

    const selectedEntry = dataList[index];
    if (!selectedEntry) {
      alert("Invalid entry selected for publishing.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("id", selectedEntry.id.toString());
    formDataToSend.append("status", "Published");
    formDataToSend.append("imageName", selectedEntry.imageName);
    formDataToSend.append(
      "categoryId",
      selectedEntry.categoryId?.toString() ?? "0"
    );
    formDataToSend.append("isActive", selectedEntry.isActive.toString());
    formDataToSend.append("uploadBy", selectedEntry.uploadBy);
    formDataToSend.append("statusCode", "3");

    const username = getStorageItemLocal("username") ?? "";
    formDataToSend.append("publishBy", username);

    formDataToSend.append("imageUrls", selectedEntry.imageUrls.toString());

    const url = `${appConfig.serviceUrls.saveIndiaImageEntries}/${selectedEntry.id}`;
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(url, {
        method: "PUT",
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        logout(navigate);
        return;
      }

      if (!response.ok) throw new Error("Failed to publish entry");

      alert("Entry published successfully.");
      fetchData();
      resetForm();
      setEditingIndex(null);
      setShowForm(false);
    } catch (error) {
      console.error("Error publishing entry:", error);
      alert("Error publishing entry.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index: number) => {
    if (!dataList || !Array.isArray(dataList) || dataList.length === 0) {
      console.error("Error: dataList is empty");
      return;
    }
    const selectedEntry = dataList[index];
    if (!selectedEntry) {
      console.error("No entry found at index:", index);
      return;
    }
    setFormData({
      ...selectedEntry,
      // TODO
      imageUrls:
        typeof selectedEntry.imageUrls === "string"
          ? selectedEntry.imageUrls.split(",")
          : Array.isArray(selectedEntry.imageUrls)
            ? selectedEntry.imageUrls
            : [],
    });
    setEditingIndex(selectedEntry.id);
    setShowForm(true);
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure want to delete this entry?")) return;
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;

      const response = await fetch(
        `${appConfig.serviceUrls.saveIndiaImageEntries}/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.status === 401) {
        logout(navigate);
        <Button onClick={() => logout(navigate)}>Logout</Button>;
        return;
      }

      if (!response.ok) throw new Error("Failed to delete");

      fetchData();
      if (editingIndex !== null && dataList[editingIndex]?.id === id) {
        setEditingIndex(null);
      }
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box sx={{ marginTop: "5px" }} className="container-wraper1">
        <Box
          className="add-wrapper"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // paddingBottom: "5px",
          }}
        >
          <Typography className="bold-header-text">
            <b>Highlight</b>{" "}
          </Typography>
          <Button onClick={handleAdd} size="small" className="custom-button">
            <img src={add} alt="add" className="img-style" />{" "}
            <Typography className="btn-text">Add Image</Typography>
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 3,
            marginBottom: 2,
          }}
        >
          {loading ? (
            <>
              {" "}
              <Spinner></Spinner>
            </>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                marginTop: 2,
                width: "100%",
              }}
            >
              {dataList?.length > 0 ? (
                <Table size="small">
                  <TableHead>
                    <TableRow className="custom-table-head-row">
                      {/* <TableCell><b>ID</b></TableCell>           */}
                      <TableCell>
                        <b>Category</b>
                      </TableCell>

                      <TableCell>
                        <b>Image Name</b>
                      </TableCell>

                      <TableCell className="nowrap">
                        <b>Image</b>
                      </TableCell>

                      <TableCell className="nowrap">
                        <b>Active / Disable</b>
                      </TableCell>
                      <TableCell className="nowrap">
                        <b>Status</b>
                      </TableCell>

                      <TableCell>
                        <b>Actions</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((item, index) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.categoryName}</TableCell>
                          <TableCell>{item.imageName}</TableCell>

                          <TableCell>
                            {typeof item.imageUrls === "string" &&
                            item.imageUrls.trim() !== "" ? (
                              <Box className="description-wraper">
                                <Typography className="description-txt">
                                  View
                                </Typography>

                                <div key={index}>
                                  {/* <a
                                  href={item.imageUrls.trim()}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                > */}
                                  <IconButton
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                      handleEdit(page * rowsPerPage + index);
                                    }}
                                  >
                                    <img
                                      src={visiable}
                                      alt="visible"
                                      className="img-style"
                                    />
                                  </IconButton>
                                  {/* </a> */}
                                </div>
                                {/* ))} */}
                              </Box>
                            ) : (
                              <Typography>No Image</Typography>
                            )}
                          </TableCell>

                          <TableCell className="nowrap">
                            <Box className="status-wrapper">
                              <Box
                                className={`status-toggle1 ${
                                  item.isActive ? "active" : "Disable"
                                }`}
                              >
                                <Box className="status-circle" />
                              </Box>

                              <Typography
                                className="active-txt"
                                component="span"
                              >
                                {item.isActive ? "Active" : "Disable"}
                              </Typography>
                            </Box>
                          </TableCell>
                          {item.status === "Approved" ? (
                            <TableCell className="approved-text">
                              {item.status}
                            </TableCell>
                          ) : item.status === "Published" ? (
                            <TableCell className="approved-text">
                              {item.status}
                            </TableCell>
                          ) : item.status === "Pending" ? (
                            <TableCell className="pending-txt">
                              {item.status}
                            </TableCell>
                          ) : (
                            <TableCell className="publish-txt">
                              {item.status}
                            </TableCell>
                          )}

                          <TableCell
                            align="left"
                            className="nowrap sticky-right-top"
                          >
                            <IconButton
                              color="primary"
                              size="small"
                              className="Icon-button"
                              onClick={() => {
                                handleEdit(page * rowsPerPage + index);
                              }}
                            >
                              <img
                                src={edit}
                                alt="visiable"
                                className="img-style"
                              />
                            </IconButton>

                            {role === "System Admin" && (
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => handleDelete(item.id)}
                              >
                                <img
                                  src={delete1}
                                  alt="visiable"
                                  className="img-style"
                                />
                              </IconButton>
                            )}

                            {item.status === "Approved" && (
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() =>
                                  handlePublish(page * rowsPerPage + index)
                                }
                              >
                                <img
                                  src={approve}
                                  alt="visiable"
                                  className="img-style"
                                />
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "1rem",
                  }}
                >
                  <Typography>No Data Found</Typography>
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "1rem",

                  bottom: 0,

                  zIndex: 1,

                  overflowX: "hidden",
                }}
              >
                <Typography
                  sx={{
                    color: "#000",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "normal",
                  }}
                >
                  Showing {page * rowsPerPage + 1} to{" "}
                  {Math.min(dataList.length, page * rowsPerPage + rowsPerPage)}{" "}
                  of {dataList.length} entries
                </Typography>
                <Pagination
                  count={Math.ceil(dataList.length / rowsPerPage)}
                  page={page + 1}
                  onChange={(e, value) => setPage(value - 1)}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                />
              </Box>
            </TableContainer>
          )}
        </Box>{" "}
        <IndiaImageFormDialog
          open={showForm}
          onClose={() => setShowForm(false)}
          fetchData={fetchData}
          resetForm={resetForm}
          formData={formData}
          categories={categories}
          setFormData={setFormData}
          editingIndex={editingIndex}
          setShowForm={setShowForm}
          setEditingIndex={setEditingIndex}
          dataList={dataList}
        />
      </Box>
    </>
  );
};

export default IndiaImage;
